import { Divider, Modal, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import api from "../../api/api";

// set formValues at open

function InstallmentCallsReportModal({ afterUpdate = () => {} }, ref) {
  const [roadmapId, setRoadmapId] = useState("");
  const [open, setOpen] = useState(false);

  const { reset, control, getValues } = useForm();

  useImperativeHandle(ref, () => ({
    open: (roadmapId, reports) => {
      setRoadmapId(roadmapId);

      const dd = {};
      reports.forEach((report, index) => {
        dd[`call_${index + 1}_time`] = report.calledAt
          ? new Date(report.calledAt)
          : null;
        dd[`call_${index + 1}_status`] = report.status;
        dd[`call_${index + 1}_note`] = report.note;
        dd[`call_${index + 1}_order`] = report.order;
      });
      reset(dd);
      setOpen(true);
    },
  }));

  const closeHandler = () => {
    setOpen(false);
    reset();
    setRoadmapId("");
  };

  const submitReports = () => {
    const values = getValues();

    const tempReports = [1, 2, 3].map((i) => ({
      order: i,
      status: values[`call_${i}_status`] ?? null,
      note: values[`call_${i}_note`] ?? null,
      calledAt: values[`call_${i}_time`] ?? null,
    }));

    api
      .put("/installment-tracking-call", { reports: tempReports, roadmapId })
      .then(() => afterUpdate(roadmapId, tempReports));
    closeHandler();
  };

  const renderCallSection = (index, title) => (
    <div key={index}>
      <h3 style={{ marginBottom: 8 }}>{title}</h3>

      <div style={{ display: "flex", gap: "1rem" }}>
        <div style={{ width: "50%" }}>
          <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
            ساعت تماس:
          </p>
          <Controller
            name={`call_${index}_time`}
            control={control}
            render={({ field }) => (
              <DatePicker
                clearable
                style={{ width: "100%" }}
                format="HH:mm - YYYY/MM/DD"
                calendar={persian}
                locale={persian_fa}
                value={field.value}
                onChange={(date) => {
                  const jsDate = date?.toDate?.();
                  field.onChange(jsDate || null);
                }}
                plugins={[
                  <TimePicker style={{ width: "100%" }} position="left" />,
                ]}
              />
            )}
          />
        </div>

        <div style={{ width: "50%" }}>
          <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>
            وضعیت:
          </p>
          <Controller
            name={`call_${index}_status`}
            control={control}
            rules={{ required: "این فیلد الزامی است" }}
            render={({ field }) => (
              <Select
                {...field}
                style={{ width: "100%" }}
                options={[
                  {
                    label: "موفق به پرداخت نشده بود",
                    value: "unsuccessfulPaymentAttempt",
                  },
                  { label: "یادآوری", value: "reminder" },
                  { label: "عدم پاسخ‌گویی", value: "nonResponsive" },
                  { label: "نارضایتی از محصول", value: "dissatisfaction" },
                ]}
                onChange={(value) => field.onChange(value)}
              />
            )}
          />
        </div>
      </div>

      <p style={{ padding: "0", transform: "translateY(0.5rem)" }}>یادداشت:</p>
      <Controller
        name={`call_${index}_note`}
        control={control}
        render={({ field }) => <TextArea rows={4} {...field} />}
      />
    </div>
  );

  return (
    <Modal
      open={open}
      destroyOnClose
      onCancel={closeHandler}
      onOk={submitReports}
      okText="ثبت گزارش"
      cancelText="انصراف"
    >
      {renderCallSection(1, "تماس اول")}
      <Divider />
      {renderCallSection(2, "تماس دوم")}
      <Divider />
      {renderCallSection(3, "تماس سوم")}
    </Modal>
  );
}

export default forwardRef(InstallmentCallsReportModal);
